import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { compose } from 'redux';
import { deepDiver } from 'helpers/utilities';
import validate from '../validate';
import FieldItems from 'components/shared/FieldItems/FieldItems';
import AddUnitForm from './AddUnitForm';
import { SavedUnits } from './SavedUnits';
import { RenderError } from 'components/shared/RenderError';

class Units extends Component {
  render() {
    const { handleSubmit } = this.props;
    return (
      <div className="row" style={{ marginBottom: '25px' }}>
        <div>
          <h3 style={{ textAlign: 'center', margin: '25px 0px 5px 0px' }}>Unit(s)</h3>
          <p style={{ textAlign: 'center', marginBottom: '15px' }}>
            The information added here will be used to assign all of the building&#39;s units to
            this property. You will be able to add existing tenant information once your property is
            created.
          </p>
        </div>

        <Field name="hasUnit" component={RenderError} />

        <form onSubmit={handleSubmit}>{this.renderFieldItems()}</form>

        <div id="button" style={{ marginBottom: '75px' }} />
      </div>
    );
  }

  renderFieldItems = () => {
    const { singleUnit, floorPlans } = this.props;
    const showAddAdditional = singleUnit !== 'true';
    if (!showAddAdditional) {
      return (
        <AddUnitForm name="units[0]" index={0} formProps={{ floorPlans, showAddAdditional }} />
      );
    }
    return (
      <FieldItems
        name="units"
        formName={this.props.form}
        renderSavedItems={SavedUnits}
        savedItemsProps={{ unitTypes: this.props.unitTypes }}
        renderForm={AddUnitForm}
        dialogHeader="Add Unit"
        buttonVerbiageOverride="Add Unit"
        initialValues={{
          is_rentable: true,
          furnished: false,
          smoking: false,
          is_accessible: false,
        }}
        formProps={{ floorPlans, showAddAdditional }}
      />
    );
  };
}

export default compose(
  connect(state => ({
    singleUnit: formValueSelector('add_property')(state, 'is_single_unit'),
    floorPlans: formValueSelector('add_property')(state, 'floor_plans'),
    unitTypes: deepDiver(state, 'companyDetails.companyPreferences.unit_types') || [],
  })),
  reduxForm({
    form: 'add_property',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    validate,
  })
)(Units);
